import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=102526e0"
import script from "./CategoryTabs.vue?vue&type=script&lang=js"
export * from "./CategoryTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports